export const BACKGROUND_VIDEO_URL =
    'https://framerusercontent.com/assets/v5vkagxJD4kCx5MGVARxnD0CzJ8.mp4'
